// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case {
  padding-top: 180px;
  @media screen and (max-width: 600px) {
   padding-top: 0;
    
   }
}
.case__container {
  width: 1150px;
  height: 100%;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    width: 100%;
    
   }
}
.case__left {
  display: flex;
  padding-top: 40px;
}
.case__right {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  width: 100%;
  @media screen and (max-width: 600px) {
    margin-left: 0;
    
   }
}
.case__title {
  text-align: left;
  color: #1e1c1a;
  font-family: Roboto;
  font-size: 40px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 50px;
  margin: 0;
}
.case__text {
  color: #1e1c1a;
  font-family: Roboto;
  font-size: 19px;
  letter-spacing: 0;
  line-height: 30px;
  text-align: left;
  margin-top: 25px;
  margin-bottom: 0;
}
.case__text-ai {
  font-weight: 600;
}
.case__list {
  margin-top: 24px;
}
.case__list-block{
    display: flex;
    margin-bottom: 12px;
}
.case__list-item {
  margin: 0;
  color: #1e1c1a;
  font-family: Roboto;
  font-size: 19px;
  letter-spacing: 0;
  line-height: 30px;
 
  text-align: left;
  margin-left: 12px;
}
.case__list-item b{
    font-weight: 600;
  }
.case__list-dot{
    height: 8px;
    width: 8px;
    background-color: #F93433;
    border-radius: 50%;
    display: flex;
    min-width: 8px;
    margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Case/Case.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB;GACC,cAAc;;GAEd;AACH;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd;IACE,sBAAsB;IACtB,WAAW;;GAEZ;AACH;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX;IACE,cAAc;;GAEf;AACH;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;EACE,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;;EAEjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;IACI,gBAAgB;EAClB;AACF;IACI,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".case {\n  padding-top: 180px;\n  @media screen and (max-width: 600px) {\n   padding-top: 0;\n    \n   }\n}\n.case__container {\n  width: 1150px;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  margin: 0 auto;\n  @media screen and (max-width: 600px) {\n    flex-direction: column;\n    width: 100%;\n    \n   }\n}\n.case__left {\n  display: flex;\n  padding-top: 40px;\n}\n.case__right {\n  display: flex;\n  flex-direction: column;\n  margin-left: 30px;\n  width: 100%;\n  @media screen and (max-width: 600px) {\n    margin-left: 0;\n    \n   }\n}\n.case__title {\n  text-align: left;\n  color: #1e1c1a;\n  font-family: Roboto;\n  font-size: 40px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 50px;\n  margin: 0;\n}\n.case__text {\n  color: #1e1c1a;\n  font-family: Roboto;\n  font-size: 19px;\n  letter-spacing: 0;\n  line-height: 30px;\n  text-align: left;\n  margin-top: 25px;\n  margin-bottom: 0;\n}\n.case__text-ai {\n  font-weight: 600;\n}\n.case__list {\n  margin-top: 24px;\n}\n.case__list-block{\n    display: flex;\n    margin-bottom: 12px;\n}\n.case__list-item {\n  margin: 0;\n  color: #1e1c1a;\n  font-family: Roboto;\n  font-size: 19px;\n  letter-spacing: 0;\n  line-height: 30px;\n \n  text-align: left;\n  margin-left: 12px;\n}\n.case__list-item b{\n    font-weight: 600;\n  }\n.case__list-dot{\n    height: 8px;\n    width: 8px;\n    background-color: #F93433;\n    border-radius: 50%;\n    display: flex;\n    min-width: 8px;\n    margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
